export default "__VITE_ASSET__BoLmc2s4__"